var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.01294 0.0241185L8.58611 7.59729C8.87553 7.88671 9.26143 8.03142 9.67144 8.03142C10.0815 8.03142 10.4673 7.86259 10.7568 7.59729L18.3299 0.0241185C18.2817 0.0241185 18.2335 0 18.1852 0H1.15765C1.10941 0.0241184 1.06118 0.0241185 1.01294 0.0241185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.408 8.27257C10.9497 8.73082 10.3227 8.99612 9.64736 8.99612C8.97204 8.99612 8.36908 8.73082 7.88671 8.27257L0.168829 0.554688C0.0723551 0.747635 0 0.9647 0 1.18177V11.8421C0 12.4933 0.530604 12.9998 1.15768 12.9998H18.137C18.7882 12.9998 19.2947 12.4692 19.2947 11.8421V1.18177C19.2947 0.9647 19.2224 0.747635 19.1259 0.578806L11.408 8.27257Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.06a2e4274ff30559467b463fe8835f48.svg";
export { ForwardRef as ReactComponent };